import { ActionIcon, Button, Container, Group, TagsInput, TagsInputProps, rem } from '@mantine/core';
import SearchIcon from '@/icons/search.svg';
import CloseIcon from '@/icons/close.svg';

type SearchKeywordInputProps = {
  onClear?: () => void;
} & TagsInputProps;

export function SearchKeywordInput({ onChange, value, name, placeholder, data, onClear }: SearchKeywordInputProps) {
  return (
    <Group gap={0} wrap='nowrap' align='stretch' miw={300} maw={500}>
      <TagsInput
        name={name}
        styles={{
          input: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        }}
        splitChars={[' ', ',']}
        data={data}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        leftSection={
          <Container mt={rem(4)}>
            <SearchIcon style={{ width: rem(18), height: rem(18) }} />
          </Container>
        }
        rightSection={
          onClear ? (
            <ActionIcon onClick={onClear} bg='gray.1' c='gray.9'>
              <CloseIcon />
            </ActionIcon>
          ) : null
        }
      />
      <Button
        miw={100}
        h='auto'
        variant='default'
        ml={-1}
        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
      >
        Search
      </Button>
    </Group>
  );
}
